import { render } from "./OtherResultIntermiadiateBlock.vue?vue&type=template&id=e1b4f516&scoped=true&ts=true"
import script from "./OtherResultIntermiadiateBlock.vue?vue&type=script&lang=ts"
export * from "./OtherResultIntermiadiateBlock.vue?vue&type=script&lang=ts"

import "./OtherResultIntermiadiateBlock.vue?vue&type=style&index=0&id=e1b4f516&lang=scss&scoped=true"

import exportComponent from "/Users/nicolacentonze/Desktop/Projects/cons-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1b4f516"]])

export default __exports__